/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React, { useState } from 'react';

import { CountryAndStates } from './address/country_state';
import SelectField from './address/select_field';
import { getRequiredSuffix } from '../../../helpers/form_libs';
import Icon from '../../OC/oc-icon';
import Text from '../../OC/oc-text';
import { connectLocation } from '../../location/LocationConnectors';
import LabelWrapper from '../LabelWrapper';

const companyField = css`
  input,
  select {
    margin-bottom: 5px;
    @media (max-width: 700px) {
      width: auto;
    }
  }

  .error {
    color: #d4074d;
    font-size: 12px;
    font-weight: bold;
  }

  .FieldsRow {
    display: flex;
    flex-direction: row;

    @media (max-width: 700px) {
      flex-direction: column;
    }

    .state-select.fieldItem {
      width: 33.333%;
      @media (max-width: 700px) {
        width: 100%;
      }
    }

    .fieldItem {
      width: 33.333%;

      @media (max-width: 700px) {
        width: 100%;
      }
    }
  }
`;
const mr20 = css`
  margin-right: 20px;
`;
const mb20 = css`
  margin-bottom: 1em;
`;

const Error = styled.p`
  color: #940420 !important;
  font-size: 12px;
  font-weight: bold;
`;

const AlertBox = styled.div`
  margin-top: 16px;
  padding: 16px 20px;
  background: #f7dbdb;
  color: #660014;
  font-family: OCRoboto, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.4;

  strong {
    font-weight: 700;
    color: #660014;
  }
`;

const ZipCodeWrapper = styled.div`
  position: relative;
`;

const ZipCodeInput = styled.input`
  &.invalid {
    border-color: #940420;
  }
`;

const StatusIcon = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: #940420;
`;

// eslint-disable-next-line react/function-component-definition
function CompanyInfo({ formData, onChange, schema, uiSchema, errorSchema, formContext, t }) {
  const [state, _] = useState(() => {
    // Default to US states if available
    const usCountry = CountryAndStates.find(item => item.label === 'United States');
    return usCountry ? usCountry.states : [];
  });
  const [zipCodeError, setZipCodeError] = useState('');
  const optionalFocused = formContext?.optionalFocused;

  const validateZipCode = value => {
    if (!value) {
      setZipCodeError('');
      return;
    }

    // Check if it contains non-numeric characters or is not exactly 5 digits
    if (!/^\d{5}$/.test(value)) {
      setZipCodeError(t('company_info.errors.invalid_zip_message'));
    } else {
      setZipCodeError('');
    }
  };

  const deleteEmptyField = () => {
    Object.keys(formData).forEach(key => {
      if (formData[key] === '') {
        delete formData[key];
      }
    });
  };

  return (
    <div css={companyField}>
      {/* Company Name Field */}
      <div css={mb20}>
        <LabelWrapper htmlFor="company-name">
          <Text content={schema.properties.company_name.title?.trim?.()} />
          {getRequiredSuffix(
            optionalFocused,
            (schema.required || []).includes('company_name'),
            schema.properties.company_name.type
          )}
        </LabelWrapper>
        <input
          id="company-name"
          className="form-control"
          type="text"
          placeholder={uiSchema?.company_name?.placeholder}
          onChange={e => onChange({ ...formData, company_name: e.target.value })}
          onBlur={deleteEmptyField}
          name={schema.properties.company_name.title}
          value={formData?.company_name || ''}
          required={(schema.required || []).includes('company_name')}
        />
        {errorSchema.company_name && errorSchema.company_name.__errors.length > 0 && (
          <Error aria-describedby="company_name" className="error" role="alert">
            {t('company_info.errors.company_name')}
          </Error>
        )}
      </div>

      {/* Company Location Fields Row */}
      <div className="FieldsRow">
        <div className="fieldItem" css={mr20}>
          <LabelWrapper htmlFor="company-city">
            <Text content={schema.properties.company_city.title?.trim?.()} />
            {getRequiredSuffix(
              optionalFocused,
              (schema.required || []).includes('company_city'),
              schema.properties.company_city.type
            )}
          </LabelWrapper>
          <input
            name={schema.properties.company_city.title}
            id="company-city"
            className="form-control"
            type="text"
            placeholder={uiSchema?.company_city?.placeholder}
            onChange={e => onChange({ ...formData, company_city: e.target.value })}
            onBlur={deleteEmptyField}
            value={formData?.company_city || ''}
            required={(schema.required || []).includes('company_city')}
          />
          {errorSchema.company_city && errorSchema.company_city.__errors.length > 0 && (
            <Error aria-describedby="company_city" className="error" role="alert">
              {t('company_info.errors.company_city')}
            </Error>
          )}
        </div>

        <div className="state-select fieldItem" css={mr20}>
          <SelectField
            selectTitle={schema.properties.company_state.placeholder}
            options={state}
            value={formData?.company_state || ''}
            required={(schema.required || []).includes('company_state')}
            handleChange={e => onChange({ ...formData, company_state: e.target.value })}
            name={schema.properties.company_state.title?.trim?.()}
            elementType={schema.properties.company_state.type}
            formContext={formContext}
            valid={!(errorSchema.company_state && errorSchema.company_state.__errors.length > 0)}
          />
          {errorSchema.company_state && errorSchema.company_state.__errors.length > 0 && (
            <Error aria-describedby="company_state" className="error" role="alert">
              {t('company_info.errors.company_state')}
            </Error>
          )}
        </div>

        <div className="fieldItem">
          <LabelWrapper htmlFor="company-zip">
            <Text content={schema.properties.company_zip.title?.trim?.()} />
            {getRequiredSuffix(
              optionalFocused,
              (schema.required || []).includes('company_zip'),
              schema.properties.company_zip.type
            )}
          </LabelWrapper>
          <ZipCodeWrapper>
            <ZipCodeInput
              name={schema.properties.company_zip.title}
              maxLength={5}
              id="company-zip"
              className={`form-control ${zipCodeError ? 'invalid' : ''}`}
              type="text"
              placeholder={uiSchema?.company_zip?.placeholder}
              onChange={e => {
                const { value } = e.target;
                onChange({ ...formData, company_zip: value });
              }}
              onBlur={() => {
                deleteEmptyField();
                validateZipCode(formData?.company_zip || '');
              }}
              value={formData?.company_zip || ''}
              required={(schema.required || []).includes('company_zip')}
            />
            {zipCodeError && (
              <StatusIcon>
                <Icon type="times-circle" />
              </StatusIcon>
            )}
          </ZipCodeWrapper>
          {errorSchema.company_zip && errorSchema.company_zip.__errors.length > 0 && (
            <Error aria-describedby="company_zip" className="error" role="alert">
              {t('company_info.errors.company_zip')}
            </Error>
          )}
        </div>
      </div>
      {zipCodeError && (
        <AlertBox>
          <strong>{t('company_info.errors.invalid_zip_title')}:</strong> {zipCodeError}
        </AlertBox>
      )}
    </div>
  );
}

export default connectLocation(CompanyInfo);
